<script setup lang="ts">
const props = defineProps({
  trekUri: String,
  trekPage: Object as PropType<TrekPage[]>,
});
const route = useRoute();

// Define the TrekPage interface
interface TrekPage {
  title: string;
  template: string;
  uri: string;
  menuText: string;
  isListed: boolean;
}

// First set of desired templates
const desiredTemplates = ["page", "map-page", "treks", "faqs"];
// Second set of desired templates
const desiredTemplates2 = [
  "fitness-preparation",
  "where-to-stay",
  "what-to-bring",
  "what-to-eat",
];

// Check if the link is active based on the current route
const isActiveLink = (uri: string) => {
  return route.path === `/${uri.replace(/^\/+/, "")}`;
};

// Merge filtered pages from both template sets
const combinedTrekPages = computed(() => {
  const filterByTemplate = (desiredTemplates: string[]) => {
    return (
      props.trekPage?.filter((item) => {
        return (
          item?.isListed &&
          ((item?.uri ?? "").includes(props?.trekUri ?? "") || false) &&
          desiredTemplates.includes(item?.template)
        );
      }) ?? []
    );
  };

  // Merge both filtered results
  const filteredTrekPages1 = filterByTemplate(desiredTemplates);
  const filteredTrekPages2 = filterByTemplate(desiredTemplates2);

  return [...filteredTrekPages1, ...filteredTrekPages2];
});
</script>

<template>
  <!-- Only show the h3 and section if there are matching pages -->
  <section v-if="combinedTrekPages.length" id="trekUsefulInfo">
    <h3>Trek Information</h3>
    <section class="treks-useful-info-wrap">
      <div
        v-for="(item, index) in combinedTrekPages"
        :key="index"
        class="nav-item"
        :class="[isActiveLink(item?.uri) ? 'active' : '']"
      >
        <NuxtLink class="btn from-left" :to="`/${item?.uri}`">
          {{ item?.menuText }}
        </NuxtLink>
      </div>
    </section>
  </section>
</template>
